export default "__VITE_ASSET__CUZHwiT2__"